import { render, staticRenderFns } from "./trainingFaq.vue?vue&type=template&id=990c5554&scoped=true&"
import script from "./trainingFaq.vue?vue&type=script&lang=js&"
export * from "./trainingFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990c5554",
  null
  
)

export default component.exports